
export class Year {
  Id: number;
  SiteYearId: number;
  Default: boolean;
  Status: number;
  YearType: number;
  Term: string;
  Description: string;
  Sequence: string;
  StartDate: Date;
  EndDate: Date;
  OpenForRegistration: boolean;
  UsedOnPortal: boolean;
  PortalDefault: boolean;
  EnableOnlinePayment: boolean;
  OnlineRegistration: boolean;
  ObjectiveByYear: boolean;
  CourseRequestYear: boolean;
  AYIdentifier: string;
  Disabled: boolean;
  SchoolID: number;
  SchoolCode: string;
  SchoolName: string;
  SchoolType: string;
  V10Flag: boolean;
  Visible: boolean;
  CurrentAttendanceDate: Date;
  DisplayStudentAlertsOnAttendance: boolean;
  IsOverride: boolean;
  EformYearEnabled: boolean;
  SelfRegistrationEnabled: boolean;
  QuickRegistrationEnabled: boolean;
  ReEnrollStudentEnabled: boolean;
  AddNewStudentEnabled: boolean;

  // client-side properties
  selected: boolean;

  constructor() { }

}
